import React from "react"
import { useTranslation } from "react-i18next"

import { ActionsOverlay } from "shared/ui/actions-overlay/ActionsOverlay"

import { FilteredRoomActionHandlers } from "features/room-management/model/useRoomActionHandlers"
import { useRoomActions } from "features/room-management/model/useRoomActions"

interface RoomActionsOverlayViewProps extends FilteredRoomActionHandlers {
  closeOverlay: () => void
}

export const RoomActionsOverlayView = React.memo(
  ({ closeOverlay, ...handlers }: RoomActionsOverlayViewProps) => {
    const { t } = useTranslation()
    const { actions } = useRoomActions({
      idPrefix: "actions-overlay",
      ...handlers
    })

    return (
      <ActionsOverlay
        id="room-actions"
        headline={t("Room.Actions.Actions")}
        actions={actions}
        onCancel={closeOverlay}
      />
    )
  }
)
